<template>
	<div class="status-view" :style="'background-color: ' + status.color + '; border-color: ' + borderColor + '; width: ' + size + 'px; height: ' + size + 'px; border-width: ' + borderSize + 'px;'" :title="status.label"></div>
</template>

<script>
	export default {
		props: {
			status: Object,
			borderColor: String,
			size: Number,
			borderSize: Number
		}
	}
</script>

<style lang="scss" scoped>
	.status-view {
		border-style: solid;
		border-radius: 50%;
	}
</style>